// extracted by mini-css-extract-plugin
export default {"Iframe":"Iframe_QgDHL"};